import { z } from 'zod'
import { oc } from '@orpc/contract'

export const markIncomingFaxViewed = oc
  .route({ method: 'POST', path: '/v2/incoming-faxes/{id}/viewed' })
  .input(z.object({ id: z.string() }))
  .output(z.object({ changed: z.boolean() }))
